"use client";

export const NAVIGATION_START_EVENT = "libum:navigation-start";

export type NavigationStartDetail = { targetUrl?: string };

/**
 * Pass the destination URL whenever it's known — TopLoadingBar suppresses
 * the bar for same-URL targets, since a same-route push never changes
 * pathname/searchParams and the bar would otherwise never complete.
 */
export function startNavigationFeedback(targetUrl?: string) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<NavigationStartDetail>(NAVIGATION_START_EVENT, {
      detail: { targetUrl },
    }),
  );
}
